/// <amd-module name="Repos/Tfvc/Views/FilesHub/Components/FilesHeader" />
import * as React from "react";
import { IGitItem } from "Repos/Files/Contracts";
import { FilesEditableBreadcrumb } from "Repos/FilesHubCommon/Components/FilesEditableBreadcrumb";
import { FilesHeaderCommandBar } from "Repos/FilesHubCommon/Components/FilesHeaderCommandBar";
import * as Resources from "Repos/Tfvc/Views/FilesHub/Resources";
import { ObservableValue } from "VSS/Core/Observable";
import { ScreenSize } from "VSS/Core/Util/Screen";
import { IVssPageContext } from "VSS/Platform/Context";
import { CustomHeader, HeaderTitle, HeaderTitleArea, HeaderTitleRow, TitleSize } from "VSSUI/Header";
import { Observer } from "VSSUI/Observer";
import { ScreenSizeObserver } from "VSSUI/Utilities/ScreenSize";
import { getFilesHubViewService, IFilesHubViewService } from "../FilesHubViewService";

export const FilesHeader = (props: {
    filesService: IFilesHubViewService;    
    pageContext: IVssPageContext;
    webEditingEnabled?: ObservableValue<boolean>;
}): JSX.Element => {
    const { pageContext } = props;
    return (
        <ScreenSizeObserver>
            {(screenSizeProps: { screenSize: ScreenSize }) => {
                const filesService = props.filesService;
                const webEditingEnabled = props.webEditingEnabled;
                return (
                    <Observer item={filesService.getSelectedItem()}>
                        {(props: { item: IGitItem }) => {
                            const { item } = props;
                            return (
                                <>
                                    <FilesHeaderPathRow item={item} pageContext={pageContext} screenSize={screenSizeProps.screenSize} />
                                    <CustomHeader className="repos-files-header bolt-header-with-commandbar">
                                        <HeaderTitleArea>
                                            <HeaderTitleRow>
                                                <HeaderTitle className="text-ellipsis" titleSize={TitleSize.Large}>
                                                    {item.path === filesService.getRootItem().path ? Resources.Files : item.name}
                                                </HeaderTitle>
                                            </HeaderTitleRow>
                                        </HeaderTitleArea>
                                        <FilesHeaderCommandBar
                                            filesService={filesService}
                                            item={item}
                                            saveTitle={Resources.Checkin}
                                            screenSize={screenSizeProps.screenSize}
                                            webEditingEnabled={webEditingEnabled}
                                        />
                                    </CustomHeader>
                                </>
                            );
                        }}
                    </Observer>
                );
            }}
        </ScreenSizeObserver>
    );
};

const FilesHeaderPathRow = (props: { item: IGitItem; pageContext: IVssPageContext; screenSize: ScreenSize }): JSX.Element => {
    const { item, pageContext, screenSize } = props;
    const filesService = getFilesHubViewService(pageContext);
    const pathEditMode = new ObservableValue(false);

    const rootPath = filesService.getRootItem().path;
    // If "$/", remove only "$"; if "$/Project", we remove it. Resulting path must start with "/"
    const rootLength = rootPath.length === 2 ? 1 : rootPath.length;
    const path = item.path.substr(rootLength);

    return (
        <div className="repos-files-header-path-row body-m flex-row flex-center flex-noshrink scroll-hidden">
            <FilesEditableBreadcrumb
                key="breadcrumb"
                canSearch={false}
                editMode={pathEditMode}
                filesService={filesService}
                onPathSelected={newPath => filesService.setSelectedPath(rootPath + "/" + newPath)}
                selectedPath={path}
                screenSize={screenSize}
            />
        </div>
    );
};
